/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-vars */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-restricted-syntax */
const px2remStyleKeys = [
  'left',
  'top',
  'width',
  'height',
  'font-size',
  'line-height',
  'border-width',
  'border-radius',
  'margin',
  'margin-top',
  'margin-bottom',
  'margin-left',
  'margin-right',
  'padding',
  'padding-top',
  'padding-bottom',
  'padding-left',
  'padding-right',
  'border-top-left-radius',
  'border-top-right-radius',
  'border-bottom-left-radius',
  'border-bottom-right-radius',
];
export function px2remStr(px) {
  if (typeof px === 'string') {
    // 百分数，直接返回
    if (/[\d.]+%$/.test(px)) return px;
    px = parseFloat(px);
  }
  if (isNaN(px)) return 'auto';
  return `${px / 28}rem`;
}
// const isApx = rpx => ApxReg.test(rpx);
// // TODO:之后传入handler
// // TODO:如何和模版复用
// function apx2unit(x, unit = 'px') {
//   function convert(str, p1, offset, s) {
//     return `${(p1) / 2}${unit}`;
//   }
//   const s = String(x);
//   const test = ApxReg;
//   return s.replace(test, convert);
// }
export const isAbsoluteValue = px => /^[\d.]+$/.test(px);
const dataTransform = {
  transformStyle(key, value) {
    if (key === 'background-image') {
      return `url("${value}")`;
    }
    return value;
  },
  transformStyles(styles) {
    const _styles = {};
    for (const key in styles) {
      _styles[key] = dataTransform.transformStyle(key, styles[key]);
    }
    return _styles;
  } };
function transformStyles(style = {}) {
  const standardStyle = dataTransform.transformStyles(style);


  for (const key in style) {
    if (px2remStyleKeys.includes(key)) {
      standardStyle[key] = px2remStr(standardStyle[key]);
    } else {
      // TODO:之后处理
      // standardStyle[key] = styleTransform.transformStyle(key, style[key]);
    }
  }

  // 根据position布局方式调整对应的style值
  if (style.position === 'relative') {
    standardStyle.position = 'relative';
    standardStyle.top = 0;
    standardStyle.height = 'auto';
  } else if (style.position === 'fixed') {
    // 如果没有配置z-index，动态加上
    if (!style.zIndex) {
      standardStyle.zIndex = 10;
    }
    // 如果设置了bottom值，删除top值
    if (style.bottom !== undefined) {
      delete standardStyle.top;
    }
  }

  return standardStyle;
}

// 需要透传到内部的样式
const innerStyleKey = [
  'border-color',
  'border-radius',
  'border-width',
  'border-style',
  'background-image',
  'background-color',
  'background-size',
  'background-repeat',
  'padding',
  'padding-top',
  'padding-left',
  'padding-right',
  'padding-bottom',
  'border-top-left-radius',
  'border-top-right-radius',
  'border-bottom-left-radius',
  'border-bottom-right-radius',
  'justify-content',
  'align-items',
  'overflow',
];

const miniStyle = (wrapStyle) => {
  const resStyle = {};

  Object.keys(wrapStyle).forEach((key) => {
    const value = wrapStyle[key];
    if (value) {
      resStyle[key] = value;
    }
  });

  return resStyle;
};
function getStyle(style = {}) {
  if (!style) {
    style = {};
  }
  const outerStyle = transformStyles(style);

  // 根据position布局方式调整对应的style值
  if (style.position === 'relative') {
    outerStyle.top = 0;
    outerStyle.height = 'auto';
  } else if (style.position === 'fixed') {
    // 使用absolute模拟fixed布局
    // outerStyle.position = 'absolute';

    // 如果设置了bottom值，删除top值
    if (style.bottom !== undefined) {
      delete outerStyle.top;
    }
  }


  return outerStyle;
}

export default {
  getStyle,
};
